module.exports = __webpack_public_path__ + "img/25-11-2025.41e77854.jpg";